import React, { useState } from 'react'
import ActionButton3 from '../Common/ActionButton3'
import MessageTemplateTable from '../Common/MessageTemplateTable'
import { Pagination } from 'antd';
import SelectList from '../Common/SelectList'
import ConvertButtons from './../Common/ConvertButtons';

const MessageTempModify = () => {
    const [show, setShow] = useState(true);

    const MessageInfo = [
        {
            SNo: 1,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 2,
            tempID: 120748746539875,
            msgType: 'Follow-up',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 3,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 4,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 5,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 6,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 7,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 8,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 9,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 10,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
        {
            SNo: 11,
            tempID: 120748746539874,
            msgType: 'Enquiry',
            msg: 'Dear {MEMBERNAME}, Thank you for your enquiry for {PACKAGENAME}, we would be more happy to visit us again-Automizeplus',
            action: <ActionButton3 />,
        },
    ];

    const [data, setData] = useState(MessageInfo);
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const dataRef = React.createRef();

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        } else if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <>
            <div className="px-4 py-3">

                {/* Short message start */}
                <div className='w-full '>
                    <div className='  outline-blue-700 border-sky-600 bg-sky-500 border-l-4 rounded-sm px-4 py-3 text-white mb-5 '>
                        <p className='text-xs'>DLT registration is important to use SMS service as per the new TRAI regulation. Please check the TRAI offical website for more details.</p>
                    </div>

                    <div className='  outline-blue-700 border-sky-600 bg-sky-500 border-l-4 rounded-sm px-4 py-3 text-white mb-5 '>
                        <p className='text-xs mb-1'>You can use predefined template variables for update message templete</p>
                        <p className='text-xs'>[MEMBERNAME],[GYMNAME],[PACKAGENAME],[DAY],[RECEPITNO],[RUPEE],[STARTDATE],[EXPIREDATE],[RESUMEDATE]</p>
                    </div>

                    {
                        show ? <div className='bg-green-700 flex justify-between items-center px-4 py-3 rounded-sm'>
                            <div className='flex items-center '>
                                <i class="fa-solid fa-check text-white text-xs mr-2"></i>
                                <p className='text-xs text-white'>Successfully update</p>
                            </div>
                            <button className='' onClick={() => setShow(!show)} type="submit">
                                <svg
                                    className='w-5 h-5 hover:text-red-800'
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentcolor">
                                    <path d="M0 0h24v24H0V0z" fill="none" />
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
                                </svg>
                            </button>
                        </div> : null
                    }
                    {/* Short message end */}

                    {/* Button and selectlist start*/}
                    <div className='w-full'>
                        <div className='flex sm:justify-between justify-center items-center flex-wrap py-4'>

                            <div className='flex mt-3 mb-4'>
                                <SelectList
                                    setPostPerPage={setPostPerPage}
                                    data={data}
                                />
                            </div>

                            <div className='flex mt-3 '>
                                <ConvertButtons
                                    data={data}
                                    ref={dataRef}
                                />
                            </div>

                        </div>
                    </div>
                    {/* Button and selectlist end*/}

                    {/* Message table start */}
                    <MessageTemplateTable
                        data={currentPost}
                        ref={dataRef}
                    />
                    {/* Message table end */}

                    <div className='px-4 xsm:px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
                        <p className='text-sm text-gray-800'>
                            showing {page} to {currentPost.length} of {data.length} entries
                        </p>

                        <Pagination
                            total={data.length}
                            onChange={value => setPage(value)}
                            itemRender={itemRender}
                            pageSize={postPerPage}
                            current={page}
                        />

                    </div>
                </div>
            </div>
        </>
    )
}

export default MessageTempModify
